import type { BlogItem, FooterLink, PortfolioItem, ServiceLink, SocialLink } from "@/types";

export const SERVICE_LINKS: ServiceLink[] = [
  { label: "AI Enablement",      slug: "ai-enablement",      image: "/images/ai-enablement.jpg" },
  { label: "AI Agents",          slug: "ai-agents",          image: "/images/ai-agent.jpg" },
  { label: "Web & Mobile",       slug: "web-mobile",         image: "/images/web-and-mobile.webp" },
  { label: "Staff Augmentation", slug: "staff-augmentation", image: "/images/staff-augmentation.jpg" },
  { label: "Blockchain",         slug: "blockchain",         image: "/images/blockchain.jpg" },
  { label: "Custom Platforms",   slug: "custom-platforms",   image: "/images/custom-platforms.jpg" },
];

export const PORTFOLIO_ITEMS: PortfolioItem[] = [
  { tag: "AI",          title: "AI Resume Builder",            subtitle: "HR Tech · 2025",           desc: "GPT-powered resume generator with ATS scoring and live preview.",       image: "/images/ai-resume-builder.webp" },
  { tag: "Healthcare",  title: "Healthcare AI Skin Analyst",   subtitle: "Healthcare · 2024",        desc: "Vision model + clinician dashboard analyzing 50k+ scans/mo.",            image: "/images/healthcare-ai-skin-analyst.jpg" },
  { tag: "E-commerce",  title: "E-commerce Admin Dashboard",   subtitle: "E-commerce · 2024",        desc: "Real-time orders, inventory, and analytics powering $4M/mo GMV.",        image: "/images/e-commerce-admin.jpg" },
  { tag: "AI Agents",   title: "Sales Ops Agent Platform",     subtitle: "SaaS · 2025",              desc: "Multi-agent orchestration automating 70% of CRM workflows.",             image: "/images/sales-ops-agent-platform.jpg" },
  { tag: "Mobile",      title: "Fitness Companion App",        subtitle: "Health & Fitness · 2024",  desc: "React Native app with 4.9★ rating across iOS and Android.",              image: "/images/fitness-companion-app.jpg" },
  { tag: "Blockchain",  title: "DeFi Yield Vault",             subtitle: "DeFi / Web3 · 2025",       desc: "Audited Solidity vault securing $80M TVL across L2s.",                   image: "/images/defi-yield-vault.jpg" },
];

export const BLOG_ITEMS: BlogItem[] = [
  { tag: "AI Engineering", title: "Shipping Production RAG: 7 Lessons From 14 Real Deployments", date: "May 2, 2026", read: "9 min read" },
  { tag: "AI Agents", title: "AI Agents Without the Hype: A Production Architect's Guide", date: "Apr 18, 2026", read: "12 min read" },
  { tag: "Web Engineering", title: "Next.js 15 App Router: Real-World Tradeoffs at Scale", date: "Apr 5, 2026", read: "8 min read" },
  { tag: "Mobile", title: "React Native vs Flutter in 2026: Picking the Right Stack", date: "Mar 22, 2026", read: "7 min read" },
  { tag: "Blockchain", title: "The Smart Contract Security Checklist We Run Before Every Audit", date: "Mar 8, 2026", read: "11 min read" },
];

export const CAREER_OPENINGS: string[] = [
  "Senior AI Engineer",
  "Senior Full-stack Engineer (Next.js + Python)",
  "Senior Mobile Engineer (React Native)",
  "Solutions Architect",
  "Product Designer",
  "DevOps / Platform Engineer",
];

export const FOOTER_COMPANY_LINKS: FooterLink[] = [
  { label: "About", href: "/about" },
  { label: "Careers", href: "/careers" },
  { label: "Life at Cybitix", href: "/life" },
  { label: "Contact", href: "/contact" },
  { label: "Portfolio", href: "/portfolio" },
];

export const FOOTER_SERVICES_LINKS: FooterLink[] = [
  { label: "AI Enablement", href: "/services/ai-enablement" },
  { label: "AI Agents", href: "/services/ai-agents" },
  { label: "Web & Mobile", href: "/services/web-mobile" },
  { label: "Staff Augmentation", href: "/services/staff-augmentation" },
  { label: "Blockchain", href: "/services/blockchain" },
];

export const FOOTER_RESOURCES_LINKS: FooterLink[] = [
  { label: "Blog", href: "/blog" },
  { label: "FAQ", href: "/#faq" },
  { label: "Hire a Dev", href: "/#hire" },
  { label: "Privacy Policy", href: "/privacy-policy" },
  { label: "Terms of Service", href: "/terms-of-service" },
];

export const FOOTER_SOCIAL_LINKS: SocialLink[] = [
  { label: "GitHub", href: "https://github.com/cybitix", icon: "github" },
  { label: "LinkedIn", href: "https://linkedin.com/company/cybitix", icon: "linkedin" },
  { label: "Twitter", href: "https://twitter.com/cybitix", icon: "twitter" },
  { label: "Instagram", href: "https://instagram.com/cybitix", icon: "instagram" },
  { label: "Email", href: "mailto:hello@cybitix.com", icon: "email" },
];
